import { AcquiringChannelFlags } from 'src/context/salesforce-context';

export const getDeviceIdByName = (deviceName, uniqueTerminals) => {
  const filteredArray = Object.values(uniqueTerminals).filter(
    (term) => term.name.toLowerCase() === deviceName.toLowerCase(),
  );
  if (filteredArray.length > 0) {
    return filteredArray[0].id;
  } else {
    return '';
  }
};

export const getAllDeviceIdsByName = (deviceName, uniqueTerminals) =>
  Object.values(uniqueTerminals)
    .filter((term) => term.name.toLowerCase() === deviceName.toLowerCase())
    .map((term) => term.id);

export const isVirtualorInstoreDevice = (acquiringChannel) =>
  acquiringChannel === AcquiringChannelFlags.buyInstoreFicaOnline ||
  acquiringChannel === AcquiringChannelFlags.vodapay;

export const isVirtualDevice = (acquiringChannel) =>
  acquiringChannel === AcquiringChannelFlags.vodapay;

export const getTotalDevices = (deliveries) => {
  return Object.values(deliveries)
    .flatMap((delivery) => delivery.number_of_devices)
    .reduce((quantityA, quantityB) => quantityA + quantityB, 0);
};

export const isSpecificSingleDeviceOrder = (deviceName, deliveries) => {
  if (!deviceName || !deliveries) {
    return false;
  }
  const totalDevices = getTotalDevices(deliveries);
  const totalSpecificDevice = Object.values(deliveries)
    .filter((term) => term.device_name.toLowerCase() === deviceName.toLowerCase())
    .flatMap((delivery) => delivery.number_of_devices)
    .reduce((quantityA, quantityB) => quantityA + quantityB, 0);
  return totalDevices === totalSpecificDevice;
};

export const isProductCategorySelected = (productCategory, deliveries) => {
  if (!productCategory || !deliveries) {
    return false;
  }
  const totalSpecificDevice = Object.values(deliveries)
    .filter(
      (term) =>
        term.is_product_category &&
        term.product_category.toLowerCase() === productCategory.toLowerCase(),
    )
    .flatMap((delivery) => delivery.number_of_devices)
    .reduce((quantityA, quantityB) => quantityA + quantityB, 0);
  return totalSpecificDevice > 0;
};

export const isSpecificDeviceSelected = (deviceName, deliveries) => {
  if (!deviceName || !deliveries) {
    return false;
  }
  const totalSpecificDevice = Object.values(deliveries)
    .filter((term) => term.device_name.toLowerCase() === deviceName.toLowerCase())
    .flatMap((delivery) => delivery.number_of_devices)
    .reduce((quantityA, quantityB) => quantityA + quantityB, 0);
  return totalSpecificDevice > 0;
};

export const checkAcquiringChannel = (acquiringChannel, deliveries) => {
  if (!acquiringChannel || !deliveries) {
    return false;
  }
  const totalSpecificDevice = Object.values(deliveries)
    .filter((term) => term.acquiring_channel.toLowerCase() === acquiringChannel.toLowerCase())
    .flatMap((delivery) => delivery.number_of_devices)
    .reduce((quantityA, quantityB) => quantityA + quantityB, 0);
  return totalSpecificDevice > 0;
};
